export const discussionGuideData = [
  {
    category: "Finding Your Purpose",
    kicker: "THEME 01",
    subtitle: "Exploring 'What Could Be' & Following Your Dream",
    questions: [
      {
        question: "Why did Binjamin start asking what else he could do, even though he was already good at holding trash?",
        promptForKids: "Have you ever wondered what else you could try or learn, even when you are already doing well?",
        teacherTip: "Encourage students to think about growth mindset versus staying in a comfortable routine."
      },
      {
        question: "Pepito the Hermit Crab explores out in the world among buildings, bricks, and pipes. What makes him so adventurous?",
        promptForKids: "If you could go exploring like Pepito, what is a curious place you'd like to investigate?",
        teacherTip: "Connect hermit crab shell-switching to children growing out of comfort zones into bigger possibilities."
      },
      {
        question: "What does the question 'What could be?' mean to you?",
        promptForKids: "Close your eyes: if you could build or invent anything to help your school or neighborhood, what would it be?",
        teacherTip: "Great for quick whiteboard brainstorms or collaborative drawing sessions."
      }
    ]
  },
  {
    category: "Overcoming Trauma & Hardships",
    kicker: "THEME 02",
    subtitle: "Navigating Tough Days, Feeling Overlooked & Healing",
    questions: [
      {
        question: "Dumpsters are often where things get thrown away. How can something that feels discarded discover its true worth?",
        promptForKids: "What are some things that make you feel valued when you're having a cloudy or rough day?",
        teacherTip: "Gentle entry point for discussing emotional resilience and finding beauty in unexpected places."
      },
      {
        question: "Like a hermit crab finding safe protection, how do Pepito and Binjamin remind us that vulnerability is okay?",
        promptForKids: "Who is someone you talk to or lean on when things feel scary or uncertain?",
        teacherTip: "Emphasize support systems: trusted adults, friends, and creative outlets."
      }
    ]
  },
  {
    category: "Embracing Twists & Turns",
    kicker: "THEME 03",
    subtitle: "Adapting to Change, Humor, and Friendship",
    questions: [
      {
        question: "Life doesn't always go in a straight line. What surprising surprises did Binjamin and Pepito meet?",
        promptForKids: "Share a time when something unexpected happened, and it turned out to be fun or taught you something new!",
        teacherTip: "Highlight adaptability, flexibility, and finding humor in everyday challenges."
      },
      {
        question: "How can Pepito the Hermit Crab and Binjamin inspire us to welcome friends who look or see the world differently?",
        promptForKids: "How can we make new classmates or friends feel welcome in our group?",
        teacherTip: "Fosters empathy and celebrates diverse strengths in classroom communities."
      }
    ]
  }
];

export const classroomActivities = [
  {
    title: "Binjamin & Pepito's Dream Box",
    badge: "Creative Art & Writing",
    desc: "Decorate a recycled box as Binjamin, or craft Pepito's colorful dream shell. Have each student write down a curiosity or kind goal to drop inside.",
    materials: "Recycled cartons, shells, construction paper, markers, stickers."
  },
  {
    title: "The Great Scavenger Storyboard",
    badge: "STEM & Storytelling",
    desc: "Pepito explores pipes, bricks, and tall buildings! Create an adventure map combining recyclables into a city trail for Pepito and Binjamin.",
    materials: "Cardboard tubes, egg cartons, tape, markers."
  },
  {
    title: "The Kindness & Courage Shell",
    badge: "Social-Emotional Learning",
    desc: "Design a protective 'armor of kindness' badge highlighting one quality that makes you proud of who you are.",
    materials: "Paper plates, colored pencils, safety pins or yarn."
  }
];
